import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(
  ({ breakpoints, spacing, typography, palette }) => ({
    dialog: {
      zIndex: 1300,
      '& .MuiDialog-paper': {
        backgroundColor: '#f5f5f5',
        margin: 0,
        height: '100vh',
        maxHeight: '100vh',
        maxWidth: '100vw',
        borderRadius: 0,
        overflow: 'auto'
      },
      '& .MuiBackdrop-root': {
        backgroundColor: '#f5f5f5'
      }
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100vh',
      backgroundColor: '#f5f5f5',
      position: 'relative',
      top: 0,
      left: 0,
      overflow: 'hidden'
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1600,
      margin: '0 auto',
      width: '100%',
      height: '100vh',
      backgroundColor: '#f5f5f5',
      [breakpoints.down('lg')]: {
        padding: 0
      },
      [breakpoints.up('lg')]: {
        padding: spacing(3),
        paddingTop: spacing(3)
      }
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: spacing(1),
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: '#f5f5f5',
      width: '100%',
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
      minHeight: '80px',
      [breakpoints.down('lg')]: {
        padding: spacing(2.5, 3),
        paddingLeft: spacing(2),
        paddingRight: spacing(2),
        marginBottom: 0,
        minHeight: '80px',
        alignItems: 'center'
      }
    },
    title: {
      fontSize: '28px',
      fontWeight: 700,
      color: palette.text.primary,
      lineHeight: 1.2,
      [breakpoints.down('lg')]: {
        fontSize: '24px',
        lineHeight: 1.3
      }
    },
    tenantLogo: {
      maxWidth: '200px',
      height: 'auto',
      objectFit: 'contain'
    },
    progressBar: {
      position: 'fixed',
      top: '80px',
      left: 0,
      right: 0,
      zIndex: 1001,
      width: '100%',
      height: 6,
      backgroundColor: palette.primary.shade[10],
      borderRadius: 0,
      margin: 0,
      '& .MuiLinearProgress-bar': {
        backgroundColor: palette.primary.main,
        borderRadius: 0
      },
      [breakpoints.down('lg')]: {
        top: '80px',
        height: 4
      }
    },
    inlineQuestionCounter: {
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: 600,
      color: palette.text.secondary,
      letterSpacing: '0.5px',
      marginBottom: spacing(2),
      [breakpoints.down('lg')]: {
        fontSize: '12px',
        marginBottom: spacing(1.5)
      }
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      maxWidth: '1200px',
      margin: '0 auto',
      width: '100%',
      padding: `0 ${spacing(3)}px`,
      paddingBottom: spacing(1),
      position: 'fixed',
      top: '100px',
      left: 0,
      right: 0,
      bottom: '130px',
      overflowY: 'auto',
      [breakpoints.down('lg')]: {
        top: '84px',
        bottom: '140px',
        padding: spacing(2),
        paddingBottom: spacing(2),
        margin: 0,
        maxWidth: 'none'
      }
    },
    contentWrapperWithSkip: {
      bottom: '130px',
      [breakpoints.down('lg')]: {
        bottom: '120px'
      }
    },
    contentWrapperWithoutSkip: {
      bottom: '130px',
      [breakpoints.down('lg')]: {
        bottom: '80px'
      }
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      textAlign: 'center',
      padding: spacing(2, 0),
      width: '100%',
      maxWidth: 1000
    },
    question: {
      fontSize: '32px',
      fontWeight: 700,
      marginBottom: spacing(3),
      color: palette.text.primary,
      lineHeight: 1.3,
      textAlign: 'center',
      [breakpoints.down('lg')]: {
        fontSize: '24px',
        marginBottom: spacing(2),
        lineHeight: 1.4
      }
    },
    introBanner: {
      fontSize: '32px',
      fontWeight: 700,
      color: palette.text.primary,
      lineHeight: 1.5,
      textAlign: 'center',
      maxWidth: 900,
      marginBottom: spacing(4),
      padding: spacing(2, 3),
      borderBottom: `1px solid ${palette.primary.shade[10]}`,
      [breakpoints.down('lg')]: {
        fontSize: '24px',
        marginBottom: spacing(3),
        padding: spacing(1.5, 2),
        lineHeight: 1.4
      }
    },
    subtitle: {
      fontSize: '16px',
      fontWeight: 500,
      color: 'rgba(0, 0, 0, 0.7)',
      marginBottom: spacing(5),
      lineHeight: 1.5,
      textAlign: 'center',
      [breakpoints.down('lg')]: {
        fontSize: '14px',
        marginBottom: spacing(3),
        lineHeight: 1.4
      }
    },
    optionsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: spacing(2),
      width: '100%',
      maxWidth: 1000,
      marginBottom: spacing(4),
      [breakpoints.down('md')]: {
        gridTemplateColumns: '1fr',
        gap: spacing(1.5),
        marginBottom: spacing(3)
      }
    },
    threeColumnGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: spacing(2),
      width: '100%',
      maxWidth: 1000,
      marginBottom: spacing(4),
      [breakpoints.down('md')]: {
        gridTemplateColumns: '1fr',
        gap: spacing(1.5),
        marginBottom: spacing(3)
      }
    },
    twoColumnGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: spacing(2),
      width: '100%',
      maxWidth: 1000,
      marginBottom: spacing(4),
      [breakpoints.down('md')]: {
        gridTemplateColumns: '1fr',
        gap: spacing(1.5),
        marginBottom: spacing(3)
      }
    },
    optionCard: {
      padding: spacing(3),
      border: `2px solid ${palette.grey[300]}`,
      borderRadius: 0,
      cursor: 'pointer',
      backgroundColor: 'white',
      outline: 'none',
      '&:hover': {
        borderColor: palette.primary.main,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      },
      '&.selected': {
        borderColor: palette.primary.main,
        backgroundColor: palette.primary.light + '20'
      },
      '&:focus-visible': {
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px'
      }
    },
    optionContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      minHeight: 40
    },
    optionIcon: {
      width: 24,
      height: 24,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 0,
      backgroundColor: palette.grey[200],
      color: palette.text.secondary,
      '&.selected': {
        backgroundColor: palette.primary.main,
        color: 'white'
      }
    },
    optionText: {
      ...typography.body1,
      ...typography.weight.medium,
      textAlign: 'left',
      flex: 1,
      marginRight: spacing(2),
      minWidth: 0,
      wordWrap: 'break-word',
      overflowWrap: 'break-word'
    },
    searchContainer: {
      width: '100%',
      maxWidth: 600,
      marginBottom: spacing(4),
      position: 'relative'
    },
    searchIcon: {
      position: 'absolute',
      left: spacing(1),
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#64748B',
      zIndex: 1
    },
    searchField: {
      '& .MuiOutlinedInput-root': {
        borderRadius: 8,
        paddingLeft: spacing(4.5),
        backgroundColor: 'white',
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#E2E8F0'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: palette.primary.main
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: palette.primary.main
        }
      },
      '& .MuiInputBase-input': {
        padding: spacing(1.5, 0),
        color: '#364153',
        '&::placeholder': {
          color: '#94A3B8'
        }
      }
    },
    topicsGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: spacing(1),
      width: '100%',
      maxWidth: 1000,
      marginBottom: spacing(4),
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      padding: spacing(0.5),
      paddingRight: spacing(1),
      // Dynamic height based on content, with max height only when needed
      maxHeight: 'calc(100vh - 300px)',
      overflowY: 'auto',
      [breakpoints.down('lg')]: {
        maxHeight: 'calc(100vh - 250px)'
      },
      '&::-webkit-scrollbar': {
        width: '6px'
      },
      '&::-webkit-scrollbar-track': {
        background: '#F1F5F9',
        borderRadius: '3px'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#CBD5E0',
        borderRadius: '3px',
        '&:hover': {
          background: '#94A3B8'
        }
      }
    },
    topicsGroups: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      width: '100%',
      maxWidth: 1000,
      marginBottom: spacing(4),
      padding: spacing(0.5),
      paddingRight: spacing(1)
      // No inner maxHeight/overflow here: the surrounding contentWrapper is the
      // single scroll container, avoiding nested (double) scrolling.
    },
    categoryGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1.5),
      width: '100%'
    },
    categoryGroupHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing(1.5),
      width: '100%'
    },
    categoryGroupTitle: {
      fontSize: '16px',
      fontWeight: 700,
      color: '#1E293B',
      margin: 0
    },
    categoryGroupChips: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: spacing(1),
      width: '100%',
      alignItems: 'flex-start'
    },
    seeMoreButton: {
      alignSelf: 'flex-start',
      padding: spacing(0.5, 0),
      minWidth: 'auto',
      color: palette.primary.main,
      fontSize: '14px',
      fontWeight: 600,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
        textDecoration: 'underline'
      }
    },
    topicChip: {
      borderRadius: 20,
      marginBottom: spacing(1),
      border: '1px solid #E2E8F0',
      backgroundColor: 'white',
      color: '#364153',
      fontWeight: 600,
      fontSize: '15px',
      padding: spacing(1.5, 2.5),
      minHeight: '40px',
      height: 'auto',
      maxWidth: '100%',
      outline: 'none',
      // On mobile, chips fill the full row width (one per line) so short names
      // like "HR" don't leave odd trailing whitespace.
      [breakpoints.down('sm')]: {
        width: '100%'
      },
      // Allow long category names to wrap and grow the chip height instead of
      // being truncated with an ellipsis when the row has no room.
      '& .MuiChip-label': {
        whiteSpace: 'normal',
        overflow: 'visible',
        textOverflow: 'clip',
        lineHeight: 1.3
      },
      '&.selected': {
        backgroundColor: palette.primary.main,
        color: 'white',
        borderColor: palette.primary.main,
        '&:hover': {
          backgroundColor: palette.primary.dark
        }
      },
      '&:hover': {
        backgroundColor: '#F1F5F9'
      },
      '&:focus-visible': {
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px'
      }
    },
    page2Footer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: spacing(2),
      width: '100%',
      maxWidth: 1000
    },
    otherButton: {
      borderRadius: 20,
      marginBottom: spacing(1),
      border: '1px solid #E2E8F0',
      backgroundColor: 'white',
      color: '#364153',
      fontWeight: 600,
      fontSize: '15px',
      lineHeight: 1,
      padding: spacing(1.5, 2.5),
      height: '40px',
      minHeight: '40px',
      maxHeight: '40px',
      textTransform: 'none',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&.selected': {
        backgroundColor: palette.primary.main,
        color: 'white',
        borderColor: palette.primary.main,
        '&:hover': {
          backgroundColor: palette.primary.dark
        }
      },
      '&:hover': {
        backgroundColor: '#F1F5F9'
      },
      '&:focus-visible': {
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px'
      },
      [breakpoints.down('lg')]: {
        minHeight: '44px',
        height: '44px',
        fontSize: '14px',
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    },
    otherInputContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1),
      width: '100%',
      maxWidth: 500,
      alignItems: 'center'
    },
    customTopicsDisplay: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: spacing(0.5),
      width: '100%',
      marginBottom: spacing(1),
      minHeight: '40px',
      padding: spacing(1)
    },
    otherInputLabel: {
      fontSize: '13px',
      color: '#374151',
      fontWeight: 600,
      textAlign: 'left',
      width: '100%',
      marginBottom: spacing(0.5)
    },
    messageText: {
      fontSize: '12px',
      color: palette.primary.main,
      fontWeight: 500,
      textAlign: 'left',
      width: '100%',
      marginTop: spacing(1),
      fontStyle: 'italic'
    },
    otherInputWrapper: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center'
    },
    otherInputField: {
      width: '100%',
      '& .MuiOutlinedInput-root': {
        borderRadius: 0,
        backgroundColor: 'transparent',
        borderBottom: `3px solid ${palette.primary.main}`,
        width: '100%',
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
          borderWidth: '0px'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent'
        }
      },
      '& .MuiInputBase-input': {
        color: '#364153',
        fontWeight: 600,
        fontSize: '15px',
        padding: spacing(1.5, 2.5),
        '&::placeholder': {
          color: '#94A3B8'
        }
      }
    },
    customItemChip: {
      borderRadius: 20,
      border: '1px solid #E2E8F0',
      backgroundColor: palette.primary.main,
      color: 'white',
      fontWeight: 600,
      fontSize: '15px',
      padding: spacing(1.5, 2.5),
      minHeight: '40px',
      outline: 'none',
      '& .MuiChip-deleteIcon': {
        color: 'white',
        marginLeft: spacing(0.25),
        marginRight: spacing(-1),
        '&:hover': {
          color: '#CBD5E0'
        }
      },
      '&:hover': {
        backgroundColor: palette.primary.dark
      },
      '&:focus-visible': {
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px'
      }
    },
    customItemRemoveButton: {
      color: 'white',
      padding: 0,
      minWidth: 'auto',
      width: 20,
      height: 20,
      borderRadius: '50%',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)'
      }
    },
    selectionSummaryRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: spacing(2),
      width: '100%'
    },
    selectionCount: {
      fontSize: '14px',
      color: '#475569',
      fontWeight: 500
    },
    clearAllButton: {
      flexShrink: 0,
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '14px',
      color: '#475569',
      borderColor: '#CBD5E0',
      borderRadius: 8,
      padding: spacing(0.5, 1.5),
      whiteSpace: 'nowrap',
      '&:hover': {
        borderColor: palette.primary.main,
        backgroundColor: '#F8FAFC'
      },
      '&.Mui-disabled': {
        color: '#94A3B8',
        borderColor: '#E2E8F0'
      }
    },
    navigationButtons: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      maxWidth: '1200px',
      padding: spacing(1, 3),
      marginTop: spacing(0.5),
      margin: '0 auto',
      position: 'fixed',
      bottom: '60px',
      left: 0,
      right: 0,
      zIndex: 1002,
      backgroundColor: '#f5f5f5',
      minHeight: '70px',
      [breakpoints.down('lg')]: {
        padding: spacing(1.5),
        margin: 0
      }
    },
    navigationButtonsWithSkip: {
      [breakpoints.down('lg')]: {
        bottom: '50px'
      }
    },
    navigationButtonsWithoutSkip: {
      [breakpoints.down('lg')]: {
        bottom: '0px'
      }
    },
    backButton: {
      color: palette.text.secondary,
      textDecoration: 'none',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1,
      padding: spacing(1.5, 2),
      textTransform: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      minHeight: '44px',
      height: '44px',
      borderRadius: 0,
      '&:hover': {
        textDecoration: 'underline'
      },
      '&:focus-visible': {
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px'
      },
      [breakpoints.down('lg')]: {
        fontSize: '14px',
        lineHeight: 1,
        padding: spacing(1.5, 2),
        minHeight: '44px',
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    },
    nextButton: {
      backgroundColor: palette.primary.main,
      color: 'white',
      padding: spacing(1.5, 3),
      borderRadius: 0,
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: 1,
      minWidth: 100,
      minHeight: '44px',
      height: '44px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      '&:hover': {
        backgroundColor: palette.primary.dark
      },
      '&:disabled': {
        backgroundColor: palette.grey[300],
        color: palette.text.disabled
      },
      '&:focus-visible': {
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px'
      },
      [breakpoints.down('lg')]: {
        fontSize: '14px',
        lineHeight: 1,
        padding: spacing(1.5, 3),
        minWidth: 100,
        minHeight: '44px',
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    },
    skipButton: {
      position: 'fixed',
      top: spacing(2),
      right: spacing(4),
      color: palette.text.primary,
      fontWeight: 500,
      textDecoration: 'none',
      cursor: 'pointer',
      zIndex: 1002,
      padding: spacing(1),
      outline: 'none',
      border: 'none',
      backgroundColor: 'transparent',
      '&:hover': {
        textDecoration: 'underline',
        color: palette.primary.main
      },
      '&:focus-visible': {
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px'
      },
      [breakpoints.down('lg')]: {
        display: 'none'
      }
    },
    skipButtonContainer: {
      [breakpoints.down('lg')]: {
        position: 'fixed',
        bottom: '0px',
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: '#f5f5f5',
        padding: spacing(1.5),
        textAlign: 'center',
        minHeight: '50px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        '&::before': {
          content: '""',
          display: 'block',
          width: '100%',
          maxWidth: '1200px',
          margin: '0 auto',
          borderTop: '1px solid #e0e0e0',
          marginBottom: spacing(1),
          order: 1
        },
        '& > *': {
          order: 2,
          position: 'static',
          fontSize: '14px',
          padding: spacing(0.5, 2),
          backgroundColor: 'transparent',
          border: 'none',
          color: palette.text.primary,
          fontWeight: 500,
          textDecoration: 'none',
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline',
            color: palette.primary.main
          }
        }
      }
    },
    skipButtonMobile: {
      position: 'fixed',
      top: spacing(2),
      right: spacing(4),
      color: palette.text.primary,
      fontWeight: 500,
      textDecoration: 'none',
      cursor: 'pointer',
      zIndex: 1002,
      padding: spacing(1),
      outline: 'none',
      border: 'none',
      backgroundColor: 'transparent',
      '&:hover': {
        textDecoration: 'underline',
        color: palette.primary.main
      },
      '&:focus-visible': {
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px'
      },
      [breakpoints.up('lg')]: {
        display: 'none'
      },
      [breakpoints.down('lg')]: {
        position: 'static',
        top: 'auto',
        right: 'auto',
        padding: spacing(0.5, 2),
        fontSize: '14px'
      }
    },
    closeButton: {
      position: 'fixed',
      top: spacing(1),
      right: spacing(1),
      color: palette.text.primary,
      zIndex: 1002,
      padding: spacing(1.5),
      '&:hover': {
        color: palette.primary.main
      },
      '&:focus-visible': {
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px'
      },
      [breakpoints.down('lg')]: {
        position: 'static',
        zIndex: 1001,
        marginRight: spacing(1),
        marginLeft: 'auto'
      }
    },
    goalsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: spacing(2.5),
      width: '100%',
      maxWidth: 1000,
      marginBottom: spacing(6),
      [breakpoints.down('md')]: {
        gridTemplateColumns: '1fr',
        gap: spacing(1.5),
        marginBottom: spacing(3)
      }
    },
    goalsOptionCard: {
      padding: spacing(3.5),
      border: `1px solid ${palette.grey[300]}`,
      borderRadius: 0,
      cursor: 'pointer',
      backgroundColor: 'white',
      transition: 'all 0.2s ease-in-out',
      minHeight: '80px',
      display: 'flex',
      alignItems: 'center',
      outline: 'none',
      '&:hover': {
        borderColor: palette.primary.main,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      },
      '&.selected': {
        borderColor: palette.primary.main,
        backgroundColor: palette.primary.light + '10'
      },
      '&:focus-visible': {
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px'
      }
    },
    goalsOptionContent: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing(2.5),
      width: '100%'
    },
    goalsOptionIcon: {
      width: 32,
      height: 32,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 0,
      backgroundColor: palette.grey[700],
      color: 'white',
      flexShrink: 0,
      fontSize: '18px',
      '&.selected': {
        backgroundColor: palette.primary.main,
        color: 'white'
      }
    },
    goalsOptionText: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'left',
      lineHeight: 1.4,
      color: palette.text.primary,
      flex: 1
    },
    optionIconLeft: {
      width: 40,
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: palette.grey[100],
      color: palette.text.secondary,
      marginRight: spacing(2),
      '&.selected': {
        backgroundColor: palette.primary.main,
        color: 'white'
      }
    },
    optionIconRight: {
      width: 24,
      height: 24,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: palette.primary.main,
      flexShrink: 0
    },
    timeRoleOptionCard: {
      padding: spacing(2.5),
      border: `2px solid ${palette.grey[300]}`,
      borderRadius: 0,
      cursor: 'pointer',
      backgroundColor: 'white',
      transition: 'all 0.2s ease-in-out',
      outline: 'none',
      '&:hover': {
        borderColor: palette.primary.main,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
      },
      '&.active': {
        backgroundColor: palette.primary.light + '20'
      },
      '&.selected': {
        borderColor: palette.primary.main,
        backgroundColor: palette.primary.light + '20'
      },
      '&.inactive': {
        opacity: 0.5,
        cursor: 'pointer',
        '&:hover': {
          borderColor: palette.grey[300],
          boxShadow: 'none'
        },
        '&:focus-visible': {
          opacity: 1,
          outline: `2px solid ${palette.primary.main}`,
          outlineOffset: '2px'
        }
      },
      '&:focus-visible': {
        outline: `2px solid ${palette.primary.main}`,
        outlineOffset: '2px'
      }
    },
    timeRoleOptionIcon: {
      width: 40,
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 0,
      backgroundColor: palette.grey[700],
      color: 'white',
      marginRight: spacing(2),
      '&.selected': {
        backgroundColor: palette.primary.main,
        color: 'white'
      }
    },
    timeRoleOptionText: {
      ...typography.body1,
      ...typography.weight.medium,
      textAlign: 'left',
      flex: 1,
      minWidth: 0,
      wordWrap: 'break-word',
      overflowWrap: 'break-word'
    },
    skipModalDialog: {
      zIndex: 1400,
      '& .MuiDialog-paper': {
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      }
    },
    skipModalPaper: {
      minHeight: '200px',
      padding: '0'
    },
    skipModalContent: {
      padding: '24px 24px 16px 24px',
      textAlign: 'left'
    },
    skipModalTitle: {
      fontWeight: 600,
      fontSize: '18px',
      lineHeight: '24px',
      color: palette.text.primary,
      marginBottom: '12px'
    },
    skipModalDescription: {
      fontSize: '14px',
      lineHeight: '20px',
      color: palette.text.secondary,
      marginBottom: '20px'
    },
    skipModalCheckboxContainer: {
      marginTop: '8px'
    },
    skipModalCheckbox: {
      padding: '4px',
      '&.Mui-checked': {
        color: palette.primary.main
      }
    },
    skipModalCheckboxLabel: {
      fontSize: '14px',
      lineHeight: '20px',
      color: palette.text.primary,
      '& .MuiFormControlLabel-label': {
        fontSize: '14px'
      }
    },
    skipModalActions: {
      padding: '16px 24px 24px 24px',
      justifyContent: 'flex-end',
      gap: '12px'
    },
    skipModalReturnButton: {
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: 1,
      color: palette.primary.main,
      textDecoration: 'underline',
      padding: '8px 0',
      minWidth: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      '&:hover': {
        backgroundColor: 'transparent',
        textDecoration: 'underline'
      }
    },
    skipModalCloseButton: {
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: 1,
      borderColor: palette.grey[300],
      color: palette.text.primary,
      padding: '8px 16px',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      '&:hover': {
        borderColor: palette.grey[400],
        backgroundColor: palette.grey[50]
      }
    },
    introPageContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      maxWidth: '600px',
      margin: '0 auto',
      padding: spacing(4),
      gap: spacing(3),
      [breakpoints.down('lg')]: {
        padding: spacing(2),
        gap: spacing(2)
      }
    },
    introPageTitle: {
      fontSize: '32px',
      fontWeight: 700,
      color: palette.text.primary,
      lineHeight: 1.3,
      [breakpoints.down('lg')]: {
        fontSize: '24px',
        lineHeight: 1.4
      }
    },
    introPageBody: {
      fontSize: '16px',
      color: palette.text.secondary,
      lineHeight: 1.6,
      '& strong': {
        fontWeight: 600,
        color: palette.text.primary
      },
      [breakpoints.down('lg')]: {
        fontSize: '14px',
        lineHeight: 1.5
      }
    },
    introPageButton: {
      backgroundColor: palette.primary.main,
      color: 'white',
      padding: spacing(1.5, 4),
      fontSize: '16px',
      fontWeight: 600,
      textTransform: 'none',
      borderRadius: '8px',
      marginTop: spacing(2),
      '&:hover': {
        backgroundColor: palette.primary.dark
      },
      [breakpoints.down('lg')]: {
        fontSize: '14px',
        padding: spacing(1.25, 3)
      }
    }
  })
)
